import React, { useEffect, useState } from "react";
import AddButton from "../../../components/admin/usable/AddButton";
import Pagination from "@mui/material/Pagination";
import {
  deleteCompany,
  getCompanyList,
  toggleStatus,
} from "../../../api/admin/companyApi";
import TableLoader from "../../../components/admin/usable/TableLoader";
import Switch from "@mui/joy/Switch";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import { useNavigate } from "react-router";

const CompanyList = () => {
  const navigate = useNavigate();
  const [CompanyData, setCompanyData] = useState([]);
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(10);
  const [PaginationData, setPaginationData] = useState("");
  useEffect(() => {
    getCompanyList(setCompanyData, Page, Limit, setPaginationData);
  }, [Page, Limit]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const handleDelete = (id) => {
    deleteCompany(setCompanyData, setPaginationData, Page, Limit, id);
  };
  const handleToggleStatus = (id) => {
    toggleStatus(setCompanyData, setPaginationData, Page, Limit, id);
  };
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <p className="font-semibold ">CompanyList</p>
        <AddButton
          onClick={() => navigate("/admin/company/create")}
          text="Add New Company"
          size={"sm"}
        />
      </div>
      <div>
        <div className="w-full overflow-x-auto">
          <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  ID
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Company Logo
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Company Name
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Company Address
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Primary Phone Number
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Commission Rate
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Verified
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Created By
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Enrolled At
                </th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                  Action
                </th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {CompanyData.length > 0 ? (
                <>
                  {CompanyData.map((item, index) => {
                    return (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {index + 1}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          <div className="w-20 h-12 overflow-hidden rounded-lg">
                            <img
                              className="w-full h-full object-cover"
                              src={item.companyLogo}
                              alt=""
                            />
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                          {item.companyName}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                          {item.address.slice(0, 20)}.....
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.primaryPhoneNumber}
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {item.commissionRate}%
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          <Switch
                            checked={item.isVerified === 1 ? true : false}
                          />
                        </td>
                        <td className="px-4 py-3 text-sm text-gray-700">
                          <Switch
                            checked={item.status === 1 ? true : false}
                            onChange={() => handleToggleStatus(item.id)}
                          />
                        </td>
                        <td className="px-4 py-3 text-sm text-nowrap">
                          {item.createdByName || ""}
                        </td>
                        <td className="px-4 py-3 text-sm text-nowrap">
                          {item.createdAt.slice(0, 10)}
                        </td>
                        <td className="px-4 py-3 text-sm flex gap-x-2">
                          <EditButton
                            onClick={() =>
                              navigate(`/admin/company/edit/${item.id}`)
                            }
                          />{" "}
                          <DeleteButton onClick={() => handleDelete(item.id)} />
                        </td>
                      </tr>
                    );
                  })}
                </>
              ) : (
                <TableLoader colSpan={11} />
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <div>
          <p className="text-xs">
            Showing {CompanyData.length} of {PaginationData} entries
          </p>
        </div>
        <div>
          <Pagination count={PaginationData} onChange={handlePageChange} />
        </div>
      </div>
    </div>
  );
};

export default CompanyList;
